import React from 'react'
import { List } from 'antd'
import { ListCard, Typography } from 'modules/core/components'
import { REPORT } from 'modules/core/constants'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'
import { HolderOutlined } from '@ant-design/icons'
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable'
import { DragOverlay } from '@dnd-kit/core'
import PropTypes from 'prop-types'

const CardList = ({
  loading,
  dataSource,
  activeId,
  setDataComments,
  dataComments,
  onRefetchComments,
  loadingComments,
}) => {
  const { t } = useTranslation()
  let history = useHistory()
  let { periodId } = useParams()

  const findCard = activeId && dataSource.find((el) => el.id === activeId)

  const REPORT_TYPE = {
    FINANCIERO: { name: 'CONFIG_TEXT_FINANCIAL', color: 'red' },
    ECONOMICO: { name: 'CONFIG_TEXT_ECONOMIC', color: 'blue' },
    PATRIMONIAL: { name: 'CONFIG_REPORT_PATRIMONIAL', color: 'green' },
  }

  return (
    <>
      <SortableContext items={dataSource} strategy={rectSortingStrategy}>
        <List
          loading={loading}
          grid={{ gutter: 24, xs: 1, sm: 1, md: 1, lg: 1, xl: 3, xxl: 3 }}
          dataSource={dataSource}
          renderItem={(pnl) => {
            const { id, name, has_data, total, report_type } = pnl
            return (
              <List.Item>
                {!loading && (
                  <ListCard
                    title={name}
                    type={REPORT.REPORTS_KEYS.PNL_KEY}
                    projectionId={id}
                    periodId={periodId}
                    description={t('REPORT_CARD_TITLE_NO_DATA')}
                    hasData={has_data}
                    extra={<Typography.Icon title={t('ACTION_SORT')} icon={HolderOutlined} />}
                    onClick={() =>
                      has_data && history.push(`/analisis/${periodId}/reportesplika/${id}`)
                    }
                    url={`/analisis/${periodId}/reportesplika/${id}`}
                    emptyState={{ description: t('REPORT_CARD_TITLE_NO_DATA') }}
                    dataKpi={total}
                    reportType={t(REPORT_TYPE[report_type].name)}
                    colorTag={REPORT_TYPE[report_type].color}
                    setDataComments={setDataComments}
                    dataComments={dataComments}
                    onRefetchComments={onRefetchComments}
                    loadingComments={loadingComments}
                  />
                )}
              </List.Item>
            )
          }}
        />
      </SortableContext>
      <DragOverlay adjustScale>
        {activeId ? (
          <ListCard
            title={findCard.name}
            type={REPORT.REPORTS_KEYS.PNL_KEY}
            projectionId={activeId}
            periodId={periodId}
            description={t('REPORT_CARD_TITLE_NO_DATA')}
            hasData={findCard.has_data}
            extra={<Typography.Icon icon={HolderOutlined} />}
            onClick={() =>
              findCard.has_data &&
              history.push(`/analisis/${periodId}/reportesplika/${findCard.id}`)
            }
            url={`/analisis/${periodId}/reportesplika/${findCard.id}`}
            emptyState={{ description: t('REPORT_CARD_TITLE_NO_DATA') }}
            dataKpi={findCard.total}
            reportType={t(REPORT_TYPE[findCard.report_type].name)}
            colorTag={REPORT_TYPE[findCard.report_type].color}
            setDataComments={setDataComments}
            dataComments={dataComments}
            onRefetchComments={onRefetchComments}
            loadingComments={loadingComments}
          />
        ) : null}
      </DragOverlay>
    </>
  )
}

CardList.propTypes = {
  setDataComments: PropTypes.func,
  dataComments: PropTypes.any,
  onRefetchComments: PropTypes.func,
  loadingComments: PropTypes.bool,
  activeId: PropTypes.any,
}

export default CardList
